import {setStringAsync, setUrlAsync, StringFormat} from 'expo-clipboard';
import {isAvailableAsync, shareAsync} from 'expo-sharing';
import {observable, onBecomeObserved, runInAction} from 'mobx';
import {Platform} from 'react-native';

import type {LocatorSharingState, ShareOptions} from './LocatorSharingState';

export default class LocatorSharingStateImpl
  implements LocatorSharingState, Disposable
{
  @observable.ref private accessor _canShare: boolean | undefined = undefined;
  private readonly _stack;

  constructor() {
    using stack = new DisposableStack();
    stack.defer(
      onBecomeObserved(this, '_canShare', () => {
        this._update().catch((_: unknown) => {
          console.error(_);
        });
      }),
    );
    this._stack = stack.move();
  }

  get canShare() {
    return this._canShare;
  }

  async share(_: string, options: ShareOptions) {
    if (!this._canShare) {
      return this._putIntoClipboard(_);
    }
    try {
      await shareAsync(_, {dialogTitle: options.title});
    } catch {
      return this._putIntoClipboard(_);
    }
  }

  private async _putIntoClipboard(_: string) {
    if (Platform.OS === 'ios') {
      return setUrlAsync(_);
    }
    await setStringAsync(_, {inputFormat: StringFormat.PLAIN_TEXT});
  }

  [Symbol.dispose]() {
    this._stack.dispose();
  }

  private async _update() {
    const canShare =
      Platform.OS === 'web'
        ? 'canShare' in navigator &&
          navigator.canShare({url: 'https://example.com'})
        : await isAvailableAsync();
    runInAction(() => {
      this._canShare = canShare;
    });
  }
}
